import React from 'react';
import SingleValue from '@splunk/dashboard-visualizations/SingleValue';

export default () => (
    <SingleValue
        options={{}}
        encoding={{
            trend: 'primary.foo',
            fill: {
                field: 'primary.foo',
                format: {
                    type: 'matchvalue',
                    matches: [
                        {
                            match: 'apple',
                            value: '#FFA500',
                        },
                        {
                            match: 'grape',
                            value: '#FFFF00',
                        },
                        {
                            match: 'pear',
                            value: '#800080',
                        },
                        {
                            match: 'strawberry',
                            value: '#0000FF',
                        },
                        {
                            match: 'cherry',
                            value: '#A52A2A',
                        },
                    ],
                    defaultValue: '#00FFFF',
                },
            },
        }}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    columns: [
                        [
                            'banana',
                            'apple',
                            'grape',
                            'pear',
                            'strawberry',
                            'raspberry',
                            'blueberry',
                            'cherry',
                        ],
                        [
                            '2018-08-19T00:00:00.000+00:00',
                            '2018-08-20T00:00:00.000+00:00',
                            '2018-08-21T00:00:00.000+00:00',
                            '2018-08-22T00:00:00.000+00:00',
                            '2018-08-23T00:00:00.000+00:00',
                            '2018-08-24T00:00:00.000+00:00',
                            '2018-08-25T00:00:00.000+00:00',
                            '2018-08-26T00:00:00.000+00:00',
                        ],
                    ],
                    fields: [
                        {
                            name: 'foo',
                        },
                        {
                            name: '_time',
                        },
                    ],
                },
                meta: { totalCount: 100 },
            },
        }}
    />
);
